'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _Sliders = require('scripts/components/Sliders');

var dom = {
  slider: '[data-cross-sell-slider]'
}; // Components


var bindUIActions = function bindUIActions() {
  $(document).on('beforeChange', dom.slider, function (e, slick, currentSlide, nextSlide) {
    $(dom.slider).find('[data-slick-index="' + currentSlide + '"]').removeClass('is-active');
    $(dom.slider).find('[data-slick-index="' + nextSlide + '"]').addClass('is-active');
  });
};

var initCollectionSlider = function initCollectionSlider() {
  $(document).on('init', dom.slider, function (e) {
    $(dom.slider).find('[data-slick-index="0"]').addClass('is-active');
  });

  if ($(window).width() < 992) {
    (0, _Sliders.initSlider)('cross-sell');
  }
  (0, _Sliders.reslickOn)('cross-sell');
  bindUIActions();
};

var init = exports.init = function init() {
  var target = document.querySelector(dom.slider);
  if (!target) {
    return;
  }
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          console.log('initing cross-sell');
          initCollectionSlider();
          observer.unobserve(entry.target);
        }
      });
    });
    observer.observe(target);
  } else {
    initCollectionSlider();
  }
};